
// AdsAppsMT/private/Campaign/MT/Source/BingAds.Api/BingAds.Api.Model/DateRange/DateRangePreset.cs
export const dateRangePreset = {
  Custom: _TL_('Custom'),
  Today: _TL_('Today'),
  Yesterday: _TL_('Yesterday'),
  LastSevenDays: _TL_('Last 7 days'),
  LastFourteenDays: _TL_('Last 14 days'),
  LastThirtyDays: _TL_('Last 30 days'),
  ThisWeekFromSun: _TL_('This week (Sun-Today)'),
  ThisWeekFromMon: _TL_('This week (Mon-Today)'),
  LastWeekStartingSun: _TL_('Last week (Sun-Sat)'),
  LastWeekStartingMon: _TL_('Last week (Mon-Sun)'),
  LastFourWeeksStartingSun: _TL_('Last 4 weeks (Sun-Sat)'),
  LastFourWeeksStartingMon: _TL_('Last 4 weeks (Mon-Sun)'),
  LastSixWeeksStartingSun: _TL_('Last 6 weeks (Sun-Sat)'),
  LastSixWeeksStartingMon: _TL_('Last 6 weeks (Mon-Sun)'),
  ThisMonth: _TL_('This month'),
  LastMonth: _TL_('Last month'),
  LastTwoMonths: _TL_('Last 2 months'),
  LastThreeMonths: _TL_('Last 3 months'),
  LastSixMonths: _TL_('Last 6 months'),
  ThisYear: _TL_('This year'),
  LastYear: _TL_('Last year'),
  LastTwoYears: _TL_('Last 2 years'),
  AllTime: _TL_('All time'),
};
